<template>
    <div class="input-zone">
        <div class="">{{ verboseName }}</div>
        <el-input
            v-model="localValue"
            type="textarea"
            :rows="rows"
            :disabled="disabled"
            class="viveco-input"
        >
        </el-input>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        zone: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        pageIndex: {
            type: Number,
            required: true,
        },
        auditData:{
            type: Object,
            required: true,
        },
        userData:{
            type: Array,
            required: true,
        },
        userDataAlreadySetted:{
            type: Boolean,
            required: true,
        },
        noPdfTemplate: {
            type: Boolean,
            required: true,
        }
    },

    data (){
        return {
            localValue: '',
        };
    },

    computed: {
        verboseName (){
            return this.zone.verbose_name ? this.zone.verbose_name : this.name;
        },

        rows (){
            if(this.verboseName === 'Commentaire de l\'expert'){
                return 10;
            }
            return 2;
        },
    },

    watch: {
        localValue (val){
            this.$eventBus.$emit('text-updated', {
                pageIndex: this.pageIndex,
                fieldName: this.name,
                text: val,
            });
            this.$eventBus.$emit('change-pdf-value', {
                pageIndex: this.pageIndex,
                fieldName: this.name,
                newValue: val,
            });
        },
    },
    mounted (){
        if(this.userDataAlreadySetted){
            let relatedUserData = this.userData.find((data) => data.index === this.pageIndex);
            if (relatedUserData !== undefined){
              this.localValue = relatedUserData.data[this.name];
            } else {
              this.localValue = ''
            }
        }else if(this.zone.default){
            let auditDataUsed = this.zone.default.match(/\{\{\s?\w+\s?\}\}/g);
            if(auditDataUsed){
                for(let i = 0; i < auditDataUsed.length ; i++){
                    let data = auditDataUsed[i].replace('{{', '').replace('}}', '').replace(/\s/g,'');
                    if(this.auditData[data] || this.auditData[data] === 0){

                        this.zone.default = this.zone.default.replace(auditDataUsed[i], this.auditData[data]);
                    }else{
                        this.zone.default = this.zone.default.replace(auditDataUsed[i], '');
                    }
                }
            }
            this.localValue = this.zone.default;
        }
    },

    methods: {
    },
};
</script>

<style lang="scss">
    .input-zone{
        margin-bottom: 15px;

        .viveco-input{
            .el-textarea__inner, .el-input__inner{
                border-color: #BDDE00;
                border-radius: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/report/pdfDescriptorInput.vue